<template>
  <div
    :aria-label
    :aria-labelledby
    :aria-valuemax="maxValue"
    :aria-valuenow="value"
    class="w-full"
    data-test-id="vf-meter"
    role="progressbar"
    style="height: max-content"
  >
    <span class="relative flex between">
      <span class="absolute top-1/2 w-full b-2 b-b b-brand-1 -translate-y-1/2 " />
      <span
        v-for="key in maxValue"
        :key
        class="z-1 h-4 w-4 rounded-full i-block"
        :class="[key === value ? 'bg-brand-6 forced-colors:o:bg-[ButtonBorder]' : 'hidden']"
      />
    </span>
    <span v-if="minLabel || maxLabel" class="mt-2 flex overline-2 text-micro c-brand-1 between ">
      <span>{{ minLabel }}</span>
      <span>{{ maxLabel }}</span>
    </span>
  </div>
</template>

<script lang="ts" setup>
const {
  ariaLabel,
  ariaLabelledby,
  value = 3,
  maxValue = 5
}
  = defineProps<{
    /**
     * Accessible name for the progressbar when no visible label is referenced
     */
    ariaLabel?: string
    /**
     * ID reference to the visible label that names the progressbar
     */
    ariaLabelledby?: string
    /**
     * Defines current meter value
     */
    value?: number
    /**
     * Defines meter max value and determines number of steps rendered
     */
    maxValue?: number
    /**
     * Label for low end of meter
     */
    minLabel?: string
    /**
     * Label for high end of meter
     */
    maxLabel?: string
  }>()
</script>
